module.exports = __webpack_public_path__ + "img/pin_transport_blue.7ba314d4.svg";